// import * as api from '@/api'
import usePWA, { Status } from './usePWA'
import { isIOS, isInPWA } from '@/env'
import { downloadFile } from '@/utils'
// import useTrack from '@/hooks/useTrack'
import { getInstallConfig } from '@/api/config'
import { until } from '@vueuse/core'

interface iConfig {
  install: 'Enabled' | 'Disabled'
  content: 'Normal' | 'giveEggs'
  presentAmountView: number
  time: 'OnHome' | 'AfterUserDeposit'
  interval: number
  apple: 'Desktop' | 'Appstore'
  appleLink: string
  android: 'Pwa' | 'Apk' | 'pwaApk'
  apkLink: string
}

// interface iConfigFromCh {
//     id: string,
//     promoterId: string,
//     channelName: string,
//     channelDomain: string,
//     type: number,
//     googleTemplatesId: string | null,
//     pixelId: string,
//     apiOral: string,
//     button: number,
//     install: number,
//     presentAmountView: number | null,
//     content: number,
//     time: number,
//     interval: number,
//     apple: number,
//     appleLink: string,
//     android: number,
//     apkLink: string | null,
//     giveaway: number,
//     presentAmount: number,
//     presentLimitAmount: number,
//     smsVerify: number,
//     creator: string
// }

const { status, installPWA } = usePWA()

const config = ref<iConfig | null>(null)
// const configFromCh = ref<iConfigFromCh | null>(null)

const showAddToHomeScreen = ref(false)

// const { track2Platform } = useTrack()
const updateInstallConfig = async () => {
  const { code, data } = await getInstallConfig()
  if (code === 1 && data) {
    config.value = data
  }
};

enum androidInstallType {
  Pwa = 'Pwa',
  Apk = 'Apk',
  PwaApk = 'pwaApk'
}

// const checkToInstallPWA = async () => {
//   if (!isChrome && isAndroid && isFacebookApp) {
//     launchChrome()
//     return
//   }

//   if (isSupportPWA) {
//     await installPWA();

//     if (localStorage.getItem('pwaInstalled') === '1') {
//       track2Platform('CustomizeProduct', getTrackParams())
//     }

//     return true
//   } else {
//     // showToast('Ambiente não está pronto, falha na instalação')
//     return false
//   }
// }

const downloadApk = (apkLink: string, fileName: string) => {
  apkLink
    ? downloadFile(apkLink, fileName)
    : showToast('Pacote de download não configurado')

  // track2Platform('CustomizeProduct')
}

let i = 0
const install = async (fn?: () => Promise<void>) => {
  if (!config.value) {
    console.warn('installation config is null')
    return
  }

  const { apple, appleLink, android, apkLink } = config.value
  if (isIOS) {
    if (apple == 'Desktop') {
      showAddToHomeScreen.value = true;
    } else {
      window.open(appleLink);
    }
  } else {
    const fileName = apkLink ? apkLink.split('/').pop() : '';
    if (android == androidInstallType.Apk) {
      downloadApk(apkLink, fileName!)
    } else {
      // if (!isChrome && isAndroid && isFacebookApp) {
      //   launchChrome()
      //   return
      // }

      let installPWA_FN = fn || installPWA
      await installPWA_FN()

      if (android == androidInstallType.PwaApk) {
        let a = ++i
        await until(status).toMatch(v => (v == Status.CHECK_FAILED || v == Status.USER_DISMISSED) && a == i)
        downloadApk(apkLink, fileName!)
      }
    }
  }
}

const init = async () => {
  if (isInPWA) return

  showAddToHomeScreen.value = false
  await updateInstallConfig()
}

export default function useAPP() {
  return { config, showAddToHomeScreen, install, init }
}
